<template>
  <div class="utentiinstallatoriview">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Dati dell'installatore</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="codice" v-model="formData.codice" type="text" placeholder="Codice dell'installatore" :disabled="$route.params.id[0] != 'W'"/><label for="codice">* Codice</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="8">
          <b-form-input class="slide-up" id="denominazione" v-model="formData.denominazione" type="text" placeholder="Denominazione dell'installatore" disabled/><label for="denominazione">* Denominazione</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cf" v-model="formData.cf" type="text" placeholder="Codice fiscale dell'installatore" disabled/><label for="cf">Codice Fiscale</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="piva" v-model="formData.piva" type="text" placeholder="Partita IVA dell'installatore" disabled/><label for="piva">* Partita IVA</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>RESIDENZA</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" offset-md="1" md="10">
          <b-form-input class="slide-up" id="indirizzo" v-model="formData.indirizzo" type="text" placeholder="Seleziona il tuo indirizzo" disabled/><label for="indirizzo">* Indirizzo</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>ALTRE INFORMAZIONI</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="website" v-model="formData.website" type="text" placeholder="Sito web dell'installatore" disabled/><label for="website">Sito web</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="email" v-model="formData.email" type="text" placeholder="Email dell'installatore" disabled/><label for="email">Email *</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="cellulare" v-model="formData.cellulare" type="text" placeholder="Numero di cellulare dell'installatore" disabled/><label for="cellulare">Cellulare</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="telefono" v-model="formData.telefono" type="text" placeholder="Numero del telefono fisso dell'installatore" disabled/><label for="telefono">Telefono fisso</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="fax" v-model="formData.fax" type="text" placeholder="Numero del Fax dell'installatore" disabled/><label for="fax">Fax</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="formData.note" rows="3" max-rows="6" disabled/><label for="note">Note</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>LOGO</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10">
          <file-pond ref="logo" label-idle="* Trascina o seleziona il logo da caricare" allow-multiple="false" max-files="0"/>
          <p style="color: grey">La dimensione massima del logo è di 25mb e i formati accettati sono: jpeg, png, bmp</p>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="2">        
          <b-button variant="success" size="lg" v-on:click="downloadLogo()"><font-awesome-icon icon="file-download" /> Scarica</b-button>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>DURC</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <file-pond ref="durc" label-idle="* Trascina o seleziona il DURC da caricare" allow-multiple="false" max-files="0"/>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="2">        
          <b-button variant="success" size="lg" v-on:click="downloadDURC()"><font-awesome-icon icon="file-download" /> Scarica</b-button>
          <br>
          <br>
        </b-col>
        <b-col md="4" cols="12">
          <VueCtkDateTimePicker v-model="formData.durc_scadenza" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
            <b-form-input v-model="formData.durc_scadenza" class="slide-up fix_datetime_picker" id="durc_scadenza" type="text" placeholder="Data di scadenza del DURC" disabled/><label for="durc_scadenza">Scadenza</label>
          </VueCtkDateTimePicker>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>VISURA CAMERALE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <file-pond ref="visura_camerale" label-idle="* Trascina o seleziona la visura camerale da caricare" allow-multiple="false" max-files="0"/>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="2">        
          <b-button variant="success" size="lg" v-on:click="downloadVisura()"><font-awesome-icon icon="file-download" /> Scarica</b-button>
          <br>
          <br>
        </b-col>
        <b-col md="4" cols="12">
          <VueCtkDateTimePicker v-model="formData.visura_camerale_scadenza" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
            <b-form-input v-model="formData.visura_camerale_scadenza" class="slide-up fix_datetime_picker" id="visura_camerale_scadenza" type="text" placeholder="Data di scadenza della Visura Camerale" disabled/><label for="visura_camerale_scadenza">Scadenza</label>
          </VueCtkDateTimePicker>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>LICENZA INSTALLATORE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" cols="12">
          <VueCtkDateTimePicker v-model="formData.da" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
            <b-form-input v-model="formData.da" class="slide-up fix_datetime_picker" id="da" type="text" placeholder="Data di inizio della licenza"/><label for="da">Data Attivazione</label>
          </VueCtkDateTimePicker>
          <br>
          <br>
        </b-col>
        <b-col md="6" cols="12">
          <VueCtkDateTimePicker v-model="formData.a" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
            <b-form-input v-model="formData.a" class="slide-up fix_datetime_picker" id="a" type="text" placeholder="Data di scadenza della licenza"/><label for="a">Data Scadenza</label>
          </VueCtkDateTimePicker>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" cols="12">
          <b-form-input class="slide-up" id="chiave" v-model="formData.chiave" type="text" placeholder="Chiave dell'azienda per la licenza" disabled/><label for="chiave">Chiave Licenza</label>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>STATO INSTALLATORE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col>
          <b-form-radio-group v-model="formData.stato" buttons>
            <b-form-radio :value="0" button-variant="outline-secondary">In Attesa</b-form-radio>
            <b-form-radio :value="1" button-variant="outline-success">Attivato</b-form-radio>
            <b-form-radio :value="2" button-variant="outline-dark">Rifiutato</b-form-radio>
            <b-form-radio :value="3" button-variant="outline-danger">Scaduto</b-form-radio>
            <b-form-radio :value="4" button-variant="outline-warning">In Scadenza</b-form-radio>
            <b-form-radio :value="5" button-variant="outline-info">Rinnovato</b-form-radio>
            <b-form-radio :value="6" button-variant="outline-dark">Disabilitato</b-form-radio>
          </b-form-radio-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="attivaInstallatore()"><font-awesome-icon icon="marker" /> Aggiorna</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'utentiinstallatoriview',
  data() {
    return {
      loaded: true,
      formData:{
        codice: '',
        denominazione: '',
        cf: '',
        piva: '',
        via: '',
        civico: '',
        nazione: '',
        provincia: '',
        comune: '',
        cap: '',
        website: '',
        cellulare: '',
        telefono: '',
        fax: '',
        note: '',
        durc_scadenza: null,
        visura_camerale_scadenza: null,
        email: '',
        indirizzo: '',
        stato: 0,
        da: '',
        a: '',
        chiave: ''
      }
    }
  },
  created: function(){
    this.loadInstallatore()
  },
  methods: {
    loadInstallatore(){
      Vue.http.post('utente/installatori/load/'+this.$route.params.id, {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.formData = response.body.data
            this.formData.indirizzo = this.formData.via+" "+this.formData.civico+", "+this.formData.cap+" "+this.formData.comune+"("+this.formData.provincia+")"
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    },
    attivaInstallatore(){
      Vue.http.post('utente/installatori/update/'+this.$route.params.id, {codice: this.formData.codice, da: this.formData.da, a: this.formData.a, stato: this.formData.stato}, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Installatore aggiornato con successo!',
            type: 'success'
          })
          this.$router.push('/utenti/installatori')
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    },
    downloadLogo(){
      window.open(Vue.prototype.$hostlink+"utente/installatori/download/logo/"+this.$route.params.id)
    },
    downloadDURC(){
      window.open(Vue.prototype.$hostlink+"utente/installatori/download/durc/"+this.$route.params.id)
    },
    downloadVisura(){
      window.open(Vue.prototype.$hostlink+"utente/installatori/download/visura/"+this.$route.params.id)
    }
  },
  watch: {
    'formData.da': function(n, o){
      if(this.loaded){
        this.loaded = false
        return
      }

      try{
        if(!n)
          return
        
        var x = n.split('-')

        var result = new Date(x[2]+"-"+x[1]+"-"+x[0])

        result.setFullYear(result.getFullYear() + 1)
        result = new Date(result.getTime() - (24*60*60*1000))
        
        this.formData.a = ("0"+result.getDate()).slice(-2).toString()+"-"+("0"+(result.getMonth()+1)).slice(-2).toString()+"-"+result.getFullYear()
      }catch(e){
        return
      }
    }
  }
}
</script>

<style scoped>
#codice{
  text-indent: 90px;
}

#denominazione{
  text-indent: 150px;
}

#cf{
  text-indent: 140px;
}

#piva{
  text-indent: 115px;
}

#indirizzo{
  text-indent: 100px;
}

#website{
  text-indent: 95px;
}

#cellulare{
  text-indent: 95px;
}

#telefono{
  text-indent: 130px;
}

#fax{
  text-indent: 60px;
}

#note{
  text-indent: 70px;
  line-height: 1.8;
}

#email{
  text-indent: 85px;
}

#durc_scadenza{
  text-indent: 90px;
}

#visura_camerale_scadenza{
  text-indent: 90px;
}

#da{
  text-indent: 140px;
}

#a{
  text-indent: 125px;
}

#chiave{
  text-indent: 140px;
}
</style>